__turbopack_context__.v({
  "dotHighlight": "WorldMap-module__ewbnma__dotHighlight",
  "dotIndicator": "WorldMap-module__ewbnma__dotIndicator",
  "pulsatingHighlight": "WorldMap-module__ewbnma__pulsatingHighlight",
  "pulsatingIndicator": "WorldMap-module__ewbnma__pulsatingIndicator",
  "pulsatingOpacity": "WorldMap-module__ewbnma__pulsatingOpacity",
});
